<template>
  <v-container fluid grid-list-md v-loading="isLoadingGeneral">
    <dps-subheader @on-dates-selected="onDatesSelected" :is-loading="isLoadingGeneral"></dps-subheader>

    <v-layout row wrap v-if="isFullControlled">
      <v-flex xs12 md3 sm6 v-for="box in boxes" :key="box.title">
        <info-dashboard-box
          :title="box.title"
          :mask-title="box.maskTitle"
          :big-text-value="box.bigTextValue"
          :small-text-value="box.smallTextValue"
          :box-class="box.boxClass"
          :title-class="box.titleClass"
          :class-icon="box.classIcon"
        ></info-dashboard-box>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex sm12 md6>
        <availability-graph-box :parking-id="parkingId" class="spacing-top" ref="availabilityGraphBox"></availability-graph-box>
      </v-flex>
      <v-flex sm12 md6>
        <booking-graph-box :parking-id="parkingId" class="spacing-top" ref="bookingGraphBox"></booking-graph-box>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import InfoDashboardBox from '@/components/commons/InfoDashboardBox.vue';
import Subheader from '@/components/commons/Subheader.vue';
import statisticService from '@/services/statisticService';
import AvailabilityGraphBox from '@/components/commons/AvailabilityGraphBox.vue';
import BookingGraphBox from '@/components/commons/BookingGraphBox.vue';
import parkingService from '@/services/parkingService';
import store from '@/store';
import moment from 'moment';
import _ from 'lodash';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ParkingHome',
  components: {
    [InfoDashboardBox.name]: InfoDashboardBox,
    [Subheader.name]: Subheader,
    [BookingGraphBox.name]: BookingGraphBox,
    [AvailabilityGraphBox.name]: AvailabilityGraphBox
  },
  computed: {
    isFullControlled() {
      return store.state.parkingSelected ? store.state.parkingSelected.fullControl : true;
    }
  },
  data() {
    return {
      boxes: [
        {
          title: 'private_dash_incomes_title',
          boxClass: 'light-green',
          titleClass: 'success',
          classIcon: 'fa fa-eur',
          bigTextValue: '- €',
          smallTextValue: '- €'
        },
        {
          title: 'private_dash_bookings_title',
          boxClass: 'cyan',
          titleClass: 'info',
          classIcon: 'fa fa-users',
          bigTextValue: '-',
          smallTextValue: '-'
        },
        {
          title: 'private_dash_subscriptions_title',
          boxClass: 'amber lighten-1',
          titleClass: 'warning',
          classIcon: 'fa fa-users',
          bigTextValue: '-',
          smallTextValue: '-'
        },
        {
          title: 'private_dash_tenants_title',
          boxClass: 'grey lighten-1',
          titleClass: 'gray',
          classIcon: 'fa fa-users',
          bigTextValue: '-',
          smallTextValue: '-'
        }
      ],
      parkingId: this.$route.params.id,
      parking: {},
      lastScreenSize: this.$vuetify.breakpoint,
      isLoading: false,
      isLoadingAvaialability: false,
      isLoadingBooking: false,
      isLoadingGeneral: false
    };
  },

  created() {
    let paramsParkingSummary = {
      parking: this.parkingId
    };
    parkingService.summary(paramsParkingSummary, this.summarySuccessHandler, this.summaryErrorHandler);
  },
  destroyed() {
    EventBus.$off(keys.eventOnAvailabilityGraphDone, this.onAvailabilityGraphDone);
    EventBus.$off(keys.eventOnBookingGraphDone, this.onBookingGraphDone);
  },
  methods: {
    onAvailabilityGraphDone() {
      this.isLoadingAvaialability = false;
      this.isLoadingGeneral = this.isLoading || this.isLoadingAvaialability || this.isLoadingBooking;
    },
    onBookingGraphDone() {
      this.isLoadingBooking = false;
      this.isLoadingGeneral = this.isLoading || this.isLoadingAvaialability || this.isLoadingBooking;
    },
    onDatesSelected(params) {
      this.isLoadingGeneral = true;
      this.isLoading = true;
      this.isLoadingAvaialability = true;
      this.isLoadingBooking = true;

      // if (this.isFullControlled) {
      if (typeof this.$refs.availabilityGraphBox === 'undefined') {
        setTimeout(() => {
          this.updateCharts(params);
        }, 3000);
      } else {
        this.updateCharts(params);
      }
      // }
    },
    updateCharts(params) {
      let dates = _.clone(params.dates);

      this.$refs.availabilityGraphBox.updateAvailabilities(dates);
      this.$refs.bookingGraphBox.updateBookings(dates);

      let paramsDashboard = {
        id: this.parkingId,
        start: moment(dates[0]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        end: moment(dates[1]).format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      };

      statisticService.dashboard(paramsDashboard, this.onLoadBoxes, this.errorOnLoadBoxes);
    },
    summarySuccessHandler(data) {
      this.parking = data;
      if (typeof this.parking.contacts === 'undefined') {
        this.parking.contacts = [];
      }
      store.commit('UPDATE_PARKING_SELECTED', this.parking);

      // if (this.isFullControlled) {
      EventBus.$on(keys.eventOnAvailabilityGraphDone, this.onAvailabilityGraphDone);
      EventBus.$on(keys.eventOnBookingGraphDone, this.onBookingGraphDone);
      // }
    },
    summaryErrorHandler(error) {
      if (error.status === 404) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'error_404',
          type: 'error'
        });
      }

      this.$router.push({ name: 'Dashboard' });
    },
    onLoadBoxes(data) {
      this.isLoading = false;
      this.isLoadingGeneral = this.isLoading || this.isLoadingAvaialability || this.isLoadingBooking;

      if (typeof data.earnings === 'undefined') {
        return;
      }

      let localeIso = store.state.user.manager.localeIso;
      this.boxes = [
        {
          title: 'private_dash_incomes_title',
          boxClass: 'light-green',
          titleClass: 'success',
          classIcon: store.state.countryConstantsSelected.icon,
          bigTextValue: data.earnings.monthly,
          smallTextValue: data.earnings.current
        },
        {
          title: 'private_dash_bookings_title',
          boxClass: 'cyan',
          titleClass: 'info',
          classIcon: 'fa fa-users',
          bigTextValue: data.bookings.monthly.toLocaleString(localeIso),
          smallTextValue: data.bookings.current
        },
        {
          title: 'private_dash_subscriptions_title',
          boxClass: 'amber lighten-1',
          titleClass: 'warning',
          classIcon: 'fa fa-users',
          bigTextValue: data.subscriptions.monthly.toLocaleString(localeIso),
          smallTextValue: data.subscriptions.current
        },
        {
          title: 'private_dash_tenants_title',
          boxClass: 'grey lighten-1',
          titleClass: 'gray',
          classIcon: 'fa fa-users',
          bigTextValue: data.tenants.amount.toLocaleString(localeIso),
          smallTextValue: ''
        }
      ];
    },
    errorOnLoadBoxes() {}
  }
};
</script>

<style lang="scss" scoped>
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/parking/Home.vue